import { Query } from '../generated/nest-graphql'
import gql from 'graphql-tag'
import { newBackendClient } from '../components/clients/new-backend.client'

export const getReviewIODataFromNest = async () => {
  const result = await newBackendClient.query<Query, {}>({
    query: gql`
      query getReviewsMetaData {
        getReviewsMetaData {
          rating
          reviewCount
        }
      }
    `,
  })
  const { reviewCount, rating } = result.data.getReviewsMetaData
  return { reviewCount, rating }
}

interface GetReviewsArgs {
  cursor?: string
  limit?: number
}
export const getReviews = async (options?: GetReviewsArgs) => {
  const limit = options?.limit || 50
  const cursor = options?.cursor || null
  const result = await newBackendClient.query<Query, {}>({
    query: gql`
      query getReviews($cursor: String, $limit: Int) {
        getReviews(cursor: $cursor, limit: $limit) {
          edges {
            reviewerName
            reviewType
            rating
            comment
            branch
            dateCreated
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    `,
    variables: {
      cursor,
      limit,
    },
  })
  return result?.data?.getReviews
}
